import React from 'react';
import { Outlet } from 'react-router-dom';

function SocialMain() {
  return (
    <div>
      <h1>Social</h1>
      <p>Voici la section Social de l'application.</p>
      <Outlet /> {/* Ici s'afficheront les pages BulletinDeSalaire ou AjouterEmploye */}
    </div>
  );
}

export default SocialMain;
